const strict = true;

const getDefaultState = () => {
  return {
    confirmDialog: {
      active: false,
      title: "",
      message: "",
      params: {
        title: null,
        msg: null
      },
      cancelBtnLabel: "",
      cancelBtnClb: null,
      confirmBtnLabel: "",
      confirmBtnClb: null
    }
  };
};

const state = getDefaultState();

const getters = {
  confirmDialog: state => state.confirmDialog
};

const mutations = {
  RESET(state) {
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  openConfirmDialog(
    state,
    {
      title,
      message,
      params,
      cancelBtnLabel,
      cancelBtnClb,
      confirmBtnLabel,
      confirmBtnClb
    }
  ) {
    state.confirmDialog.active = true;
    state.confirmDialog.title = title;
    state.confirmDialog.message = message;
    state.confirmDialog.params = params;
    state.confirmDialog.cancelBtnLabel = cancelBtnLabel;
    state.confirmDialog.cancelBtnClb = cancelBtnClb;
    state.confirmDialog.confirmBtnLabel = confirmBtnLabel;
    state.confirmDialog.confirmBtnClb = confirmBtnClb;
  },
  closeConfirmDialog(state) {
    state.confirmDialog = {
      active: false,
      title: "",
      message: "",
      params: {
        title: null,
        msg: null
      },
      cancelBtnLabel: "",
      cancelBtnClb: null,
      confirmBtnLabel: "",
      confirmBtnClb: null
    };
  }
};

const actions = {};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
